import styled from "styled-components";

export const Container = styled.main`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const SeparateDiv = styled.div`
    display: flex;
    gap: 20px;
`;

export const FormInput = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    input[type='text']{
        &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    width: 100%;
    }
`;

export const Label = styled.label`
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-size: 14px;
    
    span{
        color: ${(props) => props.theme.colors.primary};
        margin-left: 3px;
    }
`;

export const Input = styled.input`
    &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    width: 100%;
`;

export const InforErro = styled.div`
    color: ${(props) => props.theme.colors.primary};
    font-size: 12px;
`;

export const ContentButton = styled.div``;

export const ButtonIconTable = styled.button`
    text-align: center;
    display: flex;
    background-color: ${(props) => props.theme.colors.white};
    border-radius: 30px;
    padding: 8px;
    box-shadow: 0px 1px 4px 0px ${(props) => props.theme.colors.gray.gray_100};
    
    &:hover {
        background-color: ${(props) => props.theme.colors.gray.gray_100};
    }
`;

export const Footer = styled.footer`
    display: flex;
    flex-direction: column;
    gap: 15px;
`;

export const TitleList = styled.p`
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-weight: 500;
    font-size: 14px;
`;


export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;

    thead {
        background-color: ${(props) => props.theme.colors.gray.gray_50};
        position: sticky;
        top: 0;
        z-index: 1;
    }

    th:nth-child(1),
    td:nth-child(1),
    th:last-child,
    td:last-child {
        width: 85px;
    }

    tbody {
        display: block;
        max-height: 200px;
        overflow-y: auto;
        width: 100%;
    }

    tbody::-webkit-scrollbar { 
        display: none;
    }

    tr {
        display: table;
        width: 100%;
        table-layout: fixed;
    }

    td,
    th {
        text-align: center;
        padding: 10px 0;
    }

    td > div {
        display: flex;
        justify-content: space-around;
    }
    
    & svg {
        font-size: 18px;
        
    }

    @media (max-width: 900px) {
        td, th{
            width: 100%;
        }

        tbody {
            max-height: 450px;
        }
    }
`;